import { render, staticRenderFns } from "./ManagePackages.vue?vue&type=template&id=7b4672d3&"
import script from "./ManagePackages.vue?vue&type=script&lang=js&"
export * from "./ManagePackages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports